<template>
    <div class="project-integrations" :class="{loading: loading}">
        <fieldset>
            <legend>
                <div class="row">
                    <div class="col-sm-6 col-md-7 text-right form-group pull-sm-right">
                        Integrations
                    </div>

                    <div class="col-sm-6 col-md-5 form-group align-sm-left">
                        <button type="button" class="btn btn-success" @click="open(null)" :disabled="loading">
                            Create Integration
                        </button>
                    </div>
                </div>
            </legend>

            <div class="list-group">
                <a href="javascript://void(0)" class="list-group-item"
                   :class="{'list-group-item-success active':selectedModelId === model.id}"
                   v-for="model in models"
                   :key="model.id"
                   @click="open(model.id)">
                    <h4 class="list-group-item-heading">
                        {{model.integration.title}}
                        <span v-html="model.integration.typeLabel"></span>
                        <span v-html="model.typeLabel"></span>
                        <span v-if="model.archivedLabel" v-html="model.archivedLabel"></span>
                    </h4>
                </a>
            </div>
        </fieldset>

        <project-integration ref="projectIntegrationComponent"
                             :model-id="selectedModelId"
                             :project-id="projectId"
                             @afterSave="afterSave">
            <span></span>
        </project-integration>
    </div>
</template>

<script>
    import models from "./mixins/models";
    import ProjectIntegration from "./ProjectIntegration";

    export default {
        components: { ProjectIntegration },
        mixins: [ models ],

        props: {
            projectId: {
                required: true,
                type: String
            },
        },

        computed: {
            url(){
                return '/api/projectIntegrations?_load[]=integration&project_id=' + this.projectId;
            },

            modelComponent(){
                return 'projectIntegrationComponent';
            },

            resourceKey(){
                return 'ProjectIntegrations';
            },
        },

        methods: {}
    }
</script>
